<ion-header [translucent]="true">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button (click)="cancel()">
        <ion-icon size="large" name="close-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-buttons slot="end">
      @if (!paramId) {
      <ion-button (click)="create()" [disabled]="inspectionError">{{
        "inspection.create" | translate
      }}</ion-button>
      } @if (paramId) {
      <ion-button (click)="update()" [disabled]="inspectionError">{{
        "inspection.update" | translate
      }}</ion-button>
      }
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content [fullscreen]="true">
  <div class="container">
    <div class="wide">
      <lib-date-time-picker
        [type]="'date'"
        [inputDateZulu]="newInspection.dateUtc"
        (selectedDateChanged)="dateChanged($event)"
      ></lib-date-time-picker>
    </div>

    <br />
    <ion-select
      [label]="'machinery.machine' | translate"
      mode="md"
      label-placement="floating"
      fill="outline"
      (ionChange)="selectedMachineChanged($event.target.value)"
      [value]="newInspection.machineId"
      interface="popover"
    >
      @for (value of this.machines; track value) {
      <ion-select-option [value]="value.id"
        >{{ value.inventoryNumber }} {{ value.manufacturer }}
        {{ value.type }}</ion-select-option
      >
      }
    </ion-select>
    @if(selectedMachine != null){
    <div style="margin: 5px 0 0 4px">
      {{ "inspection.lastInspection" | translate }}:
      {{ tools.formatDt(selectedMachine.lastInspectionUtc) }}
    </div>
    <div style="margin: 0 0 0 4px">
      {{ "inspection.operatingHours" | translate }}:
      {{ selectedMachine.operatingHours }}
    </div>
    @if(selectedMachine.lastInspectionUtc != null){
    <div class="wide">
      <ion-button (click)="takeLastInspectionAsTemplate()">{{
        "inspection.useLastAsTemplate" | translate
      }}</ion-button
      ><ion-button (click)="initNewForm()">{{
        "inspection.reset" | translate
      }}</ion-button>
    </div>

    } }

    <ion-textarea
      style="margin: 10px 0"
      [label]="'inspection.operatingHours' | translate"
      labelPlacement="floating"
      fill="outline"
      mode="md"
      [placeholder]="'inspection.operatingHoursPlaceholder' | translate"
      [(ngModel)]="newInspection.operatingHours"
    ></ion-textarea>
    <br />
    @for (group of INSPECTION_GROUPS; track group) {
    <div>
      @if(groupHasElements(group)){
      <div class="group-caption">{{ group.name }}</div>
      @for (element of group.inspectionElements; track element) {
      <div>
        <!--div class="subcaption centered">
                          <div>{{ element.name }}:</div>
                          <ion-checkbox></ion-checkbox>
                          <div>In Ordnung</div>
                        </div-->
        @if(newInspection.inspectionResults[element.name] != null){
        <div class="wide">
          <div style="min-width: 250px">
            <div class="subcaption">{{ element.name }}</div>
            <div class="centered" style="margin-top: 5px">
              <ion-checkbox
                [(ngModel)]="
                  newInspection.inspectionResults[element.name].success
                "
              ></ion-checkbox>
              <div style="margin-left: 5px">
                {{ "inspection.ok" | translate }}
              </div>
            </div>
          </div>
          <ion-textarea
            style="margin: 10px 0"
            [label]="'common.description' | translate"
            labelPlacement="floating"
            fill="outline"
            mode="md"
            [placeholder]="'common.addDescription' | translate"
            [(ngModel)]="
              newInspection.inspectionResults[element.name].description
            "
          ></ion-textarea>
          <ion-icon
            style="font-size: 52px; margin: 0 5px"
            (click)="removeKey(element.name)"
            name="trash-outline"
          ></ion-icon>
        </div>
        }
        <!--div class="centered">
                        <div style="margin-right: 5px">In Ordnung</div>
                        <ion-checkbox stlye="margin-right:5px"></ion-checkbox>
                        <ion-checkbox stlye="margin-right:5px"></ion-checkbox>
                        <div>Nicht in Ordnung</div>
                      </div-->
        <!--ion-textarea
                      style="margin: 10px 0"
                      [label]="'common.description' | translate"
                      labelPlacement="floating"
                      fill="outline"
                      mode="md"
                      [placeholder]="'common.addDescription' | translate"
                    ></ion-textarea-->
      </div>
      } }
    </div>
    }

    <ion-textarea
      style="margin: 10px 0"
      [label]="'common.notes' | translate"
      labelPlacement="floating"
      fill="outline"
      mode="md"
      [placeholder]="'common.addNotes' | translate"
      [(ngModel)]="newInspection.notes"
    ></ion-textarea>
    <br />
  </div>
</ion-content>
